var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "div-gpt-ad div-gpt-ad-flex",
    style: _vm.divStyle,
    attrs: { id: "div-gpt-ad-1556913755435-" + this.adId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }